/**
 * Gets url for smarty address endpoint.
 * @returns an endpoint
 */
export function getSmartyAutocompleteEndpoint() {
  const endpoint =
    process.env.NEXT_PUBLIC_REQUEST_ACCESS_SMARTY_US_AUTOCOMPLETE_ENDPOINT ??
    "";
  const key = process.env.NEXT_PUBLIC_REQUEST_ACCESS_SMARTY_US_KEY ?? "";

  const baseurl = endpoint + "key=" + key;

  if (!endpoint) {
    throw new Error("smarty endpoint not set");
  }

  return baseurl;
}
